import background from '../assets/img/authBg.png';
import logo from '../assets/img/logo.svg';
import logoGreen from '../assets/img/logo_green.svg';
import iconHome from '../assets/img/icon-home.svg';
import iconClock from '../assets/img/icon-clock.svg';
import iconBell from '../assets/img/icon-bell.svg';
import iconUser from '../assets/img/icon-user.png';

export const LOGIN_BACKGROUND = background;
export const LOGIN_BACKGROUND_COLOR = '#FFFFFF';
export const LOGO = logo;
export const LOGO_GREEN = logoGreen;
export const ICON_USER = iconUser;
export const ICON_HOME = iconHome;
export const ICON_CLOCK = iconClock;
export const ICON_BELL = iconBell;

export const appName = 'Pulsar';
// if tag not provided, default to version in package.json
export const appVersion: string =
  import.meta.env.VITE_APP_VERSION ?? import.meta.env.VITE_VERSION ?? 'local';
